module.exports = "/packs/images/svg/map-pin-white~781de81c88cc099a8b643301e5b3b43c.svg";